<template>
    <div class="flex justify-center font-bold text-3xl mt-10">404</div>
</template>
